import type { IconData } from '@stacksjs/iconify-core'

export const capsuleF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 9.858H0v-4a5 5 0 1 1 10 0zm0 2v4a5 5 0 0 1-10 0v-4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default capsuleF
